module.exports = __webpack_public_path__ + "img/boleto.26d0cf03.svg";